"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const InputText = ({ id, onValueChange = undefined, rows = 5, value = undefined, maxLength = 2000, disabled = false, placeholder }) => {
    const defaultAttributes = {
        rows: rows,
        name: id,
        id: id,
        disabled: disabled === true ? true : false,
        onChange: onValueChange,
        maxLength: maxLength,
        value: value || ''
    };
    if (placeholder) {
        defaultAttributes.placeholder = placeholder;
    }
    return (react_1.default.createElement("textarea", Object.assign({ autoComplete: "none", className: "tr__form-input-textarea apptr__input _input-textarea" }, defaultAttributes)));
};
exports.default = InputText;
//# sourceMappingURL=InputText.js.map